// Classification is based on gross strokes, never net scores or a displayed label.
export const scoreResult = (score, par) => {
  if (!['string', 'number'].includes(typeof score) || score === '' || (typeof score === 'string' && !/^\d+$/.test(score.trim()))) return null;
  const strokes = Number(score);
  if (!Number.isInteger(strokes) || strokes < 1 || strokes > 15) return null;
  if (strokes === 1) return 'ace';
  if (!Number.isInteger(par) || par < 2 || par > 7) return null;
  return ({ '-3': 'albatross', '-2': 'eagle', '-1': 'birdie', 0: 'par', 1: 'bogie' })[strokes - par] || null;
};

export const actualHole = (index, holes, startingNine) => index + (holes === 9 && startingNine === 'back' ? 10 : 1);
export const actualHolePar = (pars, index, holes, startingNine) => {
  if (!Array.isArray(pars)) return null;
  const par = pars[pars.length === 9 && holes === 9 ? index : actualHole(index, holes, startingNine) - 1];
  return Number.isInteger(par) && par >= 2 && par <= 7 ? par : null;
};

export const RESULT_LABELS = { bogie: 'Bogey', par: 'Par', birdie: 'Birdie', eagle: 'Eagle', ace: 'Hole in One!', albatross: 'Albatross' };